/**
 * @fileOverView
 * @description Vybit Collection View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var VybsTemplate = require('../../templates/widgets/vybsfollowingtemplate.html');
var VybView = require('./vybview');
var app = require('ampersand-app');

var VybsFollowingView = AmpersandView.extend({

    template: VybsTemplate,

    initialize: function(options){
        this.collection = app.vybsfollowing;
        this.entity = "vybsfollowing";
        this.lastLoad = Date.now();
    },

    render: function(){
        this.renderWithTemplate();
        if(app.vybsfollowing.models.length==0) return this;
        else this.el.querySelector("div.vfirst").remove();
        this.renderCollection(app.vybsfollowing,VybView,'#vybsfollowingtable');

        var scrollClass = app.currentPageName=="MainPage" ? "vscrolltophalf" : "vscrollfull";
        this.el.classList.add(scrollClass);
    },

    events: {
        "scroll" : "infiniteScroll"
    },

    infiniteScroll: function(){ app.utils.infiniteScroll(this); }

});

module.exports = VybsFollowingView;
